module.exports = "<h4 mat-dialog-title>{{title}}</h4>\n<mat-dialog-content [innerHTML]=\"body\"></mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-raised-button mat-dialog-close (click)=\"reject()\">Menolak</button>\n  <span class=\"fill-remaining-space\"></span>\n  <button mat-raised-button mat-dialog-close color=\"primary\" (click)=\"accept()\">Setuju</button>\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/eula/eula.component.html
// module id = ./src/app/eula/eula.component.html
// module chunks = main